import { useMutation } from "react-query";
import http from "infra/http";
import { PessoaDto } from "./typings/unidade";

function useSavePessoaUnidade(unidadeId: string, id?: string | null) {
  return useMutation(
    (data: PessoaDto) => {
      for (const key of Object.keys(data.endereco ?? {})) {
        const e = (data.endereco as any)[key];

        if (e === undefined || e === "") {
          delete (data.endereco as any)[key];
        }
      }

      if (!Object.keys(data.endereco ?? {}).length) {
        data.endereco = undefined;
      }

      if (!data.endereco) {
        delete data.endereco;
      }

      if (!data.pessoaId && !data.contatos) {
        data.contatos = [];
      }

      if (!id) {
        return http.post(`/v1/unidades/${unidadeId}/pessoas`, data);
      }

      return http.put(`/v1/unidades/${unidadeId}/pessoas/${id}`, data);
    },
    { retry: false }
  );
}

export default useSavePessoaUnidade;
